<template>
  <div class="card shadow">
    <div class="card-body">
      <form id="selectForm" method="get">
        <div class="row form-inline">
          <div class="col-10 form-group d-flex align-items-middle">
            <span class="material-symbols-outlined icon bg-soft-primary text-primary rounded-circle"> calendar_month
            </span>
            <input id="pickdate" name="date" autocomplete="off" class="form-control me-3" />

            <select class="form-control me-3" v-model="status_id" name="status" id="status">
              <option v-for="(name, key) in statuses" :key="key" :value="key">
                {{ $trans.get("__JSON__." + name) }}
              </option>
            </select>

            <select class="form-control me-3" v-model="team_id" name="team_id" id="team_id">
              <option :value="0" selected>{{ $trans.get("__JSON__.All teams") }}</option>
              <option v-for="item in teams" :key="item.id" :value="item.id">
                {{ item.name }}
              </option>
            </select>

            <select class="form-control me-3" v-model="employer_id" name="employer_id" id="employer_id">
              <option :value="0" selected>{{ $trans.get("__JSON__.All employers") }}</option>
              <option v-for="item in employers" :key="item.id" :value="item.id">
                {{ item.name }}
              </option>
            </select>

            <select v-if="status_id == 'present' || status_id == 'active'" class="form-control me-3"
              v-model="location_id" name="location_id" id="location_id">
              <option :value="0" selected>{{ $trans.get("__JSON__.All locations") }}</option>
              <option v-for="item in locations" :key="item.id" :value="item.id">
                {{ item.name }}
              </option>
            </select>

            <select v-if="status_id == 'unclear'" class="form-control me-3" v-model="employee_location_id"
              name="employee_location_id" id="employee_location_id">
              <option :value="0" selected>{{ $trans.get("__JSON__.All employee locations") }}</option>
              <option v-for="item in locations" :key="item.id" :value="item.id">
                {{ item.name }}
              </option>
            </select>

            <select v-if="status_id == 'present' || status_id == 'active'" class="form-control me-3" v-model="client_id"
              name="client_id" id="client_id">
              <option :value="0" selected>{{ $trans.get("__JSON__.All clients") }}</option>
              <option v-for="item in clients" :key="item.id" :value="item.id">
                {{ item.name }}
              </option>
            </select>
          </div>
          <div class="col-2">
            <span class="float-end" v-tooltip :title="externalemployeecount +
              ' ' +
              $trans.get('__JSON__.externals') +
              ' (' +
              Math.round((externalemployeecount / employeecount) * 100) +
              '%)'
              ">{{ employeecount }} {{ $trans.get("__JSON__.Employees") }}
            </span>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="card shadow mt-2">
    <div class="card-body">
      <div v-if="holiday" class="row">
        <div class="col">{{ $trans.get("__JSON__.Holiday") }}: {{ holiday.name }}</div>
      </div>
      <div v-for="team_event in filteredTeamEvents" class="row ml-1 me-1 mt-1">
        <div class="col-3">
        </div>
        <div class="col-9 row p-0 m-0 overflow-hidden">
          <div class="bg-teamdate col p-0 text-center d-inline-block border">
            <span class="material-symbols-outlined">event_note</span>
            {{ team_event }}
          </div>
        </div>
      </div>
      <div class="row ml-1 me-1 mt-1">
        <div class="col-3"></div>
        <div class="col-9 row p-0 m-0 overflow-hidden">
          <div v-for="hour in 24" class="col p-0 text-center d-inline-block border" :key="hour">
            {{ hour - 1 }}
          </div>
        </div>
      </div>
      <stamp-table :day="varday" :status="status_id" :location="location_id" :employee_location="employee_location_id"
        :team="team_id" @employeecount="setEmployeeCount" :employeelink="employeelink" :holiday="holiday"
        :client="client_id" :employer="employer_id" />
    </div>
  </div>

</template>

<script>
import { DateTime } from "luxon";

export default {
  name: "TimekeepingStatus",
  created() {
    console.log('Created!');
    this.status_id = this.status;
    this.varday = this.day;
    this.location_id = parseInt(this.location);
    this.employee_location_id = parseInt(this.employee_location);
    this.team_id = parseInt(this.team);
    this.employer_id = parseInt(this.employer);
    this.client_id = parseInt(this.client);
    this.fetchTeamEvents();
    this.fetchData();
  },
  data() {
    return {
      statuses: {
        all: "All statuses",
        present: "Present",
        active: "Active",
        absent: "Absent",
        sick: "Sick",
        planed: "Planed",
        unclear: "Unclear",
      },
      status_id: "all",
      locations: null,
      location_id: 0,
      employee_location_id: 0,
      teams: null,
      team_id: 0,
      employers: null,
      employer_id: 0,
      varday: null,
      employeecount: 0,
      externalemployeecount: 0,
      holiday: null,
      clients: null,
      client_id: 0,
      team_events: null,
    };
  },
  props: {
    status: String,
    day: String,
    location: String,
    employee_location: String,
    team: String,
    employer: String,
    client: String,
    employeelink: String,
    // team_events: Object,
  },
  mounted() {
    console.log('Mounted!');
    this.picker = datepicker("#pickdate", {
      onSelect: (instance, date) => {
        this.varday =
          date.getFullYear() +
          "-" +
          this.pad(date.getMonth() + 1, 2) +
          "-" +
          this.pad(date.getDate(), 2);
        this.fetchHoliday();
        if (this.status_id == "active") {
          this.status_id = "present";
        }
      },
      dateSelected: new Date(),
      formatter: (input, date, instance) => {
        input.value =
          date.getFullYear() +
          "-" +
          this.pad(date.getMonth() + 1, 2) +
          "-" +
          this.pad(date.getDate(), 2);
      },
      startDay: 1,
      maxDate: new Date()
    });
  },
  watch: {
    status_id(newValue, oldValue) {
      if (newValue == "active") {
        if (this.picker) {
          this.picker.setDate(new Date());
        }
        this.varday = this.day;
      }
      if (newValue != "present" && newValue != "active") {
        this.location_id = 0;
      }
      this.setCookies();
    },
    location_id(newValue, oldValue) {
      this.setCookies();
    },
    employee_location_id(newValue, oldValue) {
      this.setCookies();
    },
    team_id(newValue, oldValue) {
      this.setCookies();
      this.fetchTeamEvents();
    },
    employer_id(newValue, oldValue) {
      this.setCookies();
    },
    client_id(newValue, oldValue) {
      this.setCookies();
    },
    varday(newValue, oldValue) {
      this.fetchTeamEvents();
    }
  },
  computed: {
    filteredTeamEvents() {
      let eventNames = [];
      if (this.team_events) {
        let dayDateTeamEvents = this.team_events.filter(element => element.team_id == this.team_id &&
          this.varday >= DateTime.fromISO(element.start_at).toISODate()
          && this.varday <= DateTime.fromISO(element.end_at).toISODate()
        );

        if (dayDateTeamEvents.length > 0) {
          dayDateTeamEvents.forEach((teamEvent) => eventNames.push(teamEvent.name));
          return eventNames;
        }
      }
      return eventNames;

    },
  },
  methods: {
    fetchData() {
      this.fetchLocations();
      this.fetchTeams();
      this.fetchEmployers();
      this.fetchClients();
      this.fetchHoliday();
    },
    fetchHoliday() {
      axios
        .get("/api/holidays/" + this.varday, {})
        .then((resp) => {
          this.holiday = resp.data;
          if (this.holiday == "") {
            this.holiday = null;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fetchLocations() {
      axios
        .get("/api/locations", {})
        .then((resp) => {
          this.locations = resp.data.filter((location) => location.id != 0);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fetchTeams() {
      axios
        .get("/api/teams", {})
        .then((resp) => {
          this.teams = resp.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fetchClients() {
      axios
        .get("/api/clients", {})
        .then((resp) => {
          this.clients = resp.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fetchEmployers() {
      axios
        .get("/api/employers", {})
        .then((resp) => {
          this.employers = resp.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fetchTeamEvents() {
      var weekStartFrom = DateTime.now().minus({ weeks: 4 });
      var dayStartFrom = weekStartFrom.startOf('week').toISODate();
      axios
        .get("/api/teamevents", {
          params: {
            datefrom: dayStartFrom,
          },
        })
        .then((resp) => {
          this.team_events = resp.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setCookies() {
      axios
        .get("/timekeeping", {
          params: {
            status: this.status_id,
            location_id: this.location_id,
            employee_location_id: this.employee_location_id,
            team_id: this.team_id,
            employer_id: this.employer_id,
            client_id: this.client_id,
            justcookies: 1,
          },
        })
        .then((resp) => { })
        .catch((error) => {
          console.log(error);
        });
    },
    pad(num, size) {
      var s = "000000000" + num;
      return s.substr(s.length - size);
    },
    setEmployeeCount(count) {
      this.employeecount = count.employeeCount;
      this.externalemployeecount = count.externalCount;
    },
  },
};
</script>

<style lang="scss" scoped></style>
